import React, { FC } from 'react'
import { Redirect, useRouteMatch } from 'react-router-dom'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { Container, Drawer } from '@material-ui/core'
import { HeaderBar, ToLOperationsSidebar } from '../../organisms'
import { PageHeader, LoadingPanel } from '../../molecules'
import { Typography } from '../../atoms'
import { hooks } from '../../../libs'

const sidebarWidth = 256
const headerHeight = 64

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'grid',
      fallbacks: {
        display: '-ms-grid',
      },
      width: '100%',
      height: '100%',
      '-ms-grid-rows': '64px 1fr',
      '-ms-grid-columns': '1fr',
      gridTemplate: `
        'pageHeaderBar' 64px
        'pageContent' auto
      `,
    },
    headerBar: {
      gridArea: 'pageHeaderBar',
      '-ms-grid-row': 1,
      width: '100%',
      zIndex: theme.zIndex.drawer + 1,
      position: 'fixed',
    },
    content: {
      gridArea: 'pageContent',
      '-ms-grid-row': 2,
      width: '100%',
      display: 'flex',
    },
    container: {
      height: '100%',
      position: 'relative',
    },
    maxWidthLgPaddingCustom: {
      padding: '0 60px',
      minWidth: 1000,
    },
    sidebar: {
      width: sidebarWidth,
      flexShrink: 0,
    },
    sidebarPaper: {
      width: sidebarWidth,
      paddingTop: headerHeight,
    },
    main: {
      height: '100%',
      flexGrow: 1,
    },
  }),
)

interface ToLOperationsPagePresenterProps {
  children?: React.ReactNode
}

export const ToLOperationsPagePresenter: FC<ToLOperationsPagePresenterProps> = ({ children }) => {
  const classes = useStyles()
  const { hasNotificationPermission, hasOtacMaintenancePermission, hasTolOperationAccess } = hooks.useTolOperation()
  const isExactTolOperations = useRouteMatch({ path: '/tol-operations', exact: true })

  if (!hasTolOperationAccess) {
    return <Redirect to="/unauthorized" />
  }

  if (isExactTolOperations) {
    if (hasNotificationPermission) {
      return <Redirect to="/tol-operations/notifications" />
    }
    if (hasOtacMaintenancePermission) {
      return <Redirect to="/tol-operations/otac-maintenance" />
    }
  }

  return (
    <div className={`${classes.root} ieHeightAuto`}>
      <div className={classes.headerBar}>
        <HeaderBar />
      </div>
      <div className={classes.content}>
        <Drawer
          className={classes.sidebar}
          variant="permanent"
          anchor="left"
          classes={{
            paper: classes.sidebarPaper,
          }}
        >
          <ToLOperationsSidebar />
        </Drawer>
        <main className={classes.main}>
          <Container className={classes.container} classes={{ maxWidthLg: classes.maxWidthLgPaddingCustom }}>
            <LoadingPanel />
            <PageHeader>
              <Typography variant="h3" component="h1">
                ToL運用作業
              </Typography>
            </PageHeader>
            {children}
          </Container>
        </main>
      </div>
    </div>
  )
}
